import { useEffect, useRef, useState } from 'react'
import DaumPostcode from 'react-daum-postcode'
import { isMobile } from 'react-device-detect'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { getAccessToken, getProfile } from '../../api/auth'
import { getOrderSheet } from '../../api/cart'
import {
  deleteUserInfo,
  getBookedAddresses,
  getOrderList,
  getRecentAddress,
  postGuestAddressCalculate,
  postUserAddressCalculate,
} from '../../api/orderHistory'
import { getPaymentInfo } from '../../api/pay'
import { getAccumulations } from '../../api/profile'
import { BtnBlack, BtnFixed, BtnWhiteRounded } from '../../components/Button'
import Dropdown from '../../components/dropdown/Dropdown'
import Hr8 from '../../components/hr/Hr8'
import { InputCheckbox } from '../../components/input/InputCheckbox'
import { InputText, InputTextDiv, InputTextSection, InputTextTitle, TextWrap } from '../../components/input/InputText'
import { InputTextArea } from '../../components/input/InputTextArea'
import OldOrderCartCouponModal from '../../components/order/OldOrderCartCouponModal'
import OrderModal from '../../components/order/orderModal'
import OrderRecentModal from '../../components/order/OrderRecentModal'
import ProductItemOrder from '../../components/product/ProductItemOrder'
import { PageTitle } from '../../components/title/PageTitle'
import { SectionTitle } from '../../components/title/SectionTitle'
import TooltipCartCouponOrder from '../../components/tooltip/TooltipCartCouponOrder'
import TooltipOrder from '../../components/tooltip/TooltipOrder'
import {
  findObjectsWithValue,
  formatNumberWithTruncation,
  getParsedLocalStorageItem,
  getParsedSessionStorageItem,
  handleAccessToken,
  plusComma,
} from '../../js/script'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { postSupportCoin } from '../../api/login'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { ProfileRootType } from '../../@types/auth'
import { CartType, MyPayInfo, PaymentInfo } from '../../@types/cart'
import { Product } from '../../@types/coupon'
import { RecentAddressType } from '../../@types/order'
import { getSubmitCoupons } from '../../api/coupons'
import { getCategories } from '../../api/product'
import PointExchangeCenterModal from '../../components/myshopping/PointExchangeCenterModal'
import PointExchange from '../../components/myshopping/PointExchangeOrder'
import CardDeleteModal from '../../components/order/CardDeleteModal'
import OrderCartCouponCenterModal from '../../components/order/OrderCartCouponCenterModal'
import OrderCenterModal from '../../components/order/orderCenterModal'
import OrderRecentCenterModal from '../../components/order/OrderRecentCenterModal'
import PrivacyInfoCollectionAgree from '../../components/order/PrivacyInfoCollectionAgree'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { useMyContext } from '../../components/provider/MyProvider'
import { IconArrowDown, IconArrowUp, IconPlus } from '../../components/svg/IconSvg'
import '../../css/Order.css'
import { handlePostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { addPaymentInfo, initiateCheckout } from '../../js/pixelEvent'

/**
 * 주문서
 */

declare global {
  interface Window {
    returnMypay?: (paymentInfo: any) => void
  }
}

export default function Order() {
  const [isCheckboxSameOrder, setIsCheckboxSameOrder] = useState<boolean>(false) // 주문자 동일 체크박스 상태
  const [isCheckboxPaymentAgree, setIsCheckboxPaymentAgree] = useState<boolean>(false) // 결제 동의 체크박스 상태
  const [isCheckboxNonMember, setIsCheckboxNonMember] = useState<boolean>(false) // 비회원 결제 동의 체크박스 상태
  const [isCheckboxAllPoint, setIsCheckboxAllPoint] = useState<boolean>(false) // 적립금 모두 적용 체크박스 상태
  const [isModal, setIsModal] = useState<boolean>(false)
  const [orderItem, setOrderItem] = useState<CartType[]>([]) //주문 아이템
  const [orderPrice, setOrderPrice] = useState<PaymentInfo>() //주문 가격
  const [name, setName] = useState<string>('') //주문자명
  const [phone, setPhone] = useState<string>('') //주문자 폰
  const [email, setEmail] = useState<string>('') //주문자 이메일
  const [password, setPassword] = useState<string>('') // 주문자 비밀번호
  const [repassword, setRepassword] = useState<string>('') //주문자 비밀번호 재확인
  const [receiveName, setReceiveName] = useState<string>('') //받는이
  const [receiveZip, setReceiveZip] = useState<string>('') //받는사람 우편번호
  const [receiveAddress_1, setReceiveAddress_1] = useState<string>('') //받는 주소
  const [receiveAddress_2, setReceiveAddress_2] = useState<string>('') //받는 주소 상세
  const [receivePhone, setReceivePhone] = useState<string>('') //받으시는분 폰번호
  const [receiveMobile, setReceiveMobile] = useState<string>('') //받으시는분 폰번호
  const [receiveMemo, setReceiverMemo] = useState<string>('문 앞에 놓아주세요')
  const deliveryMemo: string[] = [
    '문 앞에 놓아주세요',
    '부재 시 연락 부탁드려요',
    '배송 전 미리 연락해 주세요',
    '직접 입력',
  ]
  const [visible, setVisible] = useState<boolean>(false)
  const [receiverJibun, setReceiverJibun] = useState<string>('') //받는사람 지번
  const payArray: string[] = ['신용 / 체크카드', '네이버페이', '카카오페이', '어바웃피싱 페이'] //회원일때 페이종류
  const noMemberArray: string[] = ['신용 / 체크카드', '네이버페이', '카카오페이'] //비회원 페이종류
  const [selectPayType, setSelectPayType] = useState<string>('') //선택한 페이종류
  const [selectPay, setSelectPay] = useState<string>('신용 / 체크카드') //선택한 페이이름
  const [recentModal, setRecentModal] = useState<boolean>(false) //
  const [selectCoupon, setSelectCoupon] = useState() //선택한 쿠폰
  const [cartCouponModal, setCartCouponModal] = useState<boolean>(false) //주문쿠폰 모달
  const [cartCouponTitle, setCartCouponTitle] = useState<string>('') //주문쿠폰 이름
  const [cartCoupon, setCartCoupon] = useState<any>() //주문쿠폰
  const [productCoupon, setProductCoupon] = useState<any>([]) // 상품 쿠폰
  const [modalSelectAddress, setModalSelectAddress] = useState<any>() //모달 선택 주소
  const [selectCoupons, setSelectCoupons] = useState<any>() //선택한 쿠폰
  const [couponText, setCouponText] = useState<any>([]) //상품쿠폰 이름
  const [fishingCoin, setFishingCoin] = useState<number>(0)
  const [accumulation, setAccumulation] = useState<number>(0) //적립금
  const [priceItem, setPriceItem] = useState<any>([]) // 가격 정보
  const [cardInfo, setCardInfo] = useState<any>([]) //어바웃피싱 페이 정보
  const [slideIdx, setSlideIdx] = useState<number>(0) //어파웃피싱 페이 슬라이드 인덱스
  const [submitAcc, setSubmitAcc] = useState<number>(0) //적립금
  const [pointModal, setPointModal] = useState<boolean>(false) //적립금 변환
  const [openDiscount, setOpenDiscount] = useState<boolean>(false) //할인 합계보이기
  const [cardDelete, setCardDelete] = useState<boolean>(false) //카드삭제 확인
  const [deleteModal, setDeleteModal] = useState<boolean>(false)
  const [payUserRegister, setPayUserRegister] = useState<string>('') //유저 등록했는지 코드
  const [userData, setUserData] = useState<ProfileRootType>() //유저 데이터
  const [changePop, setChangePop] = useState<boolean>(false) //마이페이 확인용
  const [pointChange, setPointChange] = useState<boolean>(false) //포인트 변경했는지
  const [cartCoupons, setCartCoupons] = useState<Product[]>([]) //쿠폰
  const [defaultAddress, setDefaultAddress] = useState<RecentAddressType[]>([]) //기본 배송지
  const [discoutAcc, setDiscoutAcc] = useState<number>(0) //할인
  const [baseAddress, setBaseAddress] = useState<any>({}) //기존 배송지
  const [agree, setAgree] = useState<boolean>(false) //동의여부
  const [myPayData, setMyPayData] = useState<MyPayInfo>() // 마이페이 데이터
  const [passwordCheck, setPasswordCheck] = useState<boolean>(false) //비밀번호 체크
  const [accumulationUsable, setAccumulationUsable] = useState<any>([])
  const [unPrice, setUnPrice] = useState<number>(0)
  const [betweenArray, setBetweenArray] = useState<any>([])
  const [firstpurchase, setFirstpurchase] = useState<boolean>(false) // 첫구매 확인인데 false가 첫구매, true가 첫구매아님
  const [checkBtn, setCheckBtn] = useState<boolean>(false)
  const [isFocus, setIsFocus] = useState<boolean>(false)
  const [inputAcc, setInputAcc] = useState<number>(0)
  const [categorys, setCategorys] = useState<any>([])
  const [selectCategorys, setSelectCategorys] = useState<any>([])
  const [nomember, setNomember] = useState<boolean>(false) //마이페이 가입 멤버 확인
  const [isLayer, setIsLayer] = useState<boolean>(false)
  const hasExecuted = useRef(false) // useRef로 실행 여부를 추적
  const { setToastMessage, setToastBtnMessage, setToastEvent, setIsToast } = useMyContext()
  const { setIsLottie, setIsLogin, hasAccessToken } = useCommonContext()
  const { isAppView } = useAppContext()
  const params = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const orderNameRef = useRef<HTMLInputElement>(null) // 주문자 정보 > 주문자 인풋 요소
  const orderPhoneRef = useRef<HTMLInputElement>(null) // 주문자 정보 > 휴대폰 번호 인풋 요소
  const orderEmailRef = useRef<HTMLInputElement>(null) // 주문자 정보 > 이메일 인풋 요소
  const deliveryNameRef = useRef<HTMLInputElement>(null) // 배송지 정보 > 받으시는 분 인풋 요소
  const deliveryAddressRef = useRef<HTMLInputElement>(null) // 배송지 정보 > 주소 인풋 요소
  const deliveryPhoneRef = useRef<HTMLInputElement>(null) // 배송지 정보 > 휴대폰 번호 인풋 요소
  const deliveryAddressDetailRef = useRef<HTMLInputElement>(null)

  const orderPasswordRef = useRef<HTMLInputElement>(null)
  const orderPasswordCheckRef = useRef<HTMLInputElement>(null)
  const receiveMemoCustomRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    document.body.style.overflow = 'unset'
  }, [])
  useEffect(() => {
    if (!location.state) return

    const { acc } = location.state

    if (acc) {
      setInputAcc(acc)
      setSubmitAcc(acc)
      setCheckBtn(true)
    } else if (discoutAcc !== 0 || accumulation !== 0) {
      const newAcc = Math.min(discoutAcc, accumulation)
      setInputAcc(newAcc)
      setSubmitAcc(newAcc)
      setCheckBtn(true)
      setIsCheckboxAllPoint(true)
    }
  }, [discoutAcc])

  useEffect(() => {
    getCategories().then((res) => {
      setCategorys(res.data)
    })
  }, [])

  // 웹뷰 함수 호출
  useEffect(() => {
    // 전역 스코프에 returnMypay 함수 정의
    window.returnMypay = function (paymentInfo: any) {
      if (paymentInfo.date) {
        setChangePop((prev: any) => !prev)
      }
      if (paymentInfo.url) {
        const result = paymentInfo.url?.split('?')
        navigate(`/orderFinish?${result[1]}&paytype=${paymentInfo.payType}`)
      }
    }
  }, [])
  //100원샵 상품
  useEffect(() => {
    if (orderItem) {
      const array: any = []
      orderItem.map((el: any) => {
        if (el.categoryNos.includes(787334)) {
          array.push(el)
          setBetweenArray(array)
        }
      })
    }
  }, [orderItem])

  useEffect(() => {
    if (orderItem) {
      const filterItem = orderItem.filter((el: any) => {
        return !el.accumulationUsable
      })
      setAccumulationUsable(filterItem)
    }
  }, [orderItem])
  useEffect(() => {
    if (userData) {
      if (JSON.parse(userData.additionalInfo || '').shopifyUserOrder) {
        setFirstpurchase(true)
      }
    }
  }, [userData])

  useEffect(() => {
    if (hasAccessToken) {
      getOrderList().then((res) => {
        if (res.data.items.length !== 0) {
          setFirstpurchase(true)
        }
      })
    }
  }, [location])

  useEffect(() => {
    if (betweenArray) {
      betweenArray.map((el: any) => {
        setUnPrice((prev: any) => prev + el.buyAmt)
      })
    }
  }, [betweenArray])

  useEffect(() => {
    // 하단 fixed버튼이 있다면 푸터를 밀어내야함
    const footer = document.querySelector('.footer_wrap') as HTMLElement
    if (footer) footer.style.paddingBottom = isMobile ? '108px' : '0px'
  }, [])

  useEffect(() => {
    if (orderItem) {
      orderItem.map((el: any) => {
        if (!el.accumulationUsable) {
          setUnPrice((prev: any) => prev + el.buyAmt)
        }
      })
    }
  }, [orderItem])

  useEffect(() => {
    if (hasAccessToken) {
      getItem()
    } else if (!hasAccessToken) {
      getItem()
    }
  }, [location])

  //기본배송지
  useEffect(() => {
    if (hasAccessToken) {
      getRecentAddress()
        .then((res) => {
          console.log(res.data)
          setDefaultAddress(res.data)
        })
        .catch((err) => console.log(err))
    }
  }, [])

  useEffect(() => {
    if (defaultAddress) {
      defaultAddress.map((el: any) => {
        setName(el.receiverName)
        setReceiveName(el.receiverName)
        setReceiveZip(el.receiverZipCd)
        setReceiveAddress_1(el.receiverAddress)
        setReceiverJibun(el.receiverJibunAddress)
        setReceiveAddress_2(el.receiverDetailAddress)
        setReceivePhone(el.receiverContact1?.replaceAll('-', ''))
        setIsCheckboxSameOrder(true)
      })
    }
  }, [defaultAddress])

  useEffect(() => {
    if (selectPay === '어바웃피싱 페이') {
      setSelectPayType('MY_PAY')
    } else if (selectPay === '네이버페이') {
      setSelectPayType('NAVER_EASY_PAY')
    } else if (selectPay === '신용 / 체크카드') {
      setSelectPayType('CREDIT_CARD')
    } else if (selectPay === '카카오페이') {
      setSelectPayType('KAKAO_PAY')
    }
  }, [selectPay])

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://shop-api.e-ncp.com/payments/ncp_pay.js'
    script.async = true
    document.body.appendChild(script)

    const script2 = document.createElement('script')
    script2.src = 'https://spay.kcp.co.kr/plugin/kcp_spay_hub.js'
    script2.async = true
    document.body.appendChild(script2)

    const script3 = document.createElement('script')
    script3.src = 'https://nsp.pay.naver.com/sdk/js/naverpay.min.js'
    script3.async = true
    document.body.appendChild(script3)

    const script4 = document.createElement('script')
    script4.src = 'https://spay.kcp.co.kr/plugin/kcp_spay_hub.js'
    script4.async = true
    document.body.appendChild(script4)

    const script5 = document.createElement('script')
    script5.src = 'https://wcs.naver.net/wcslog.js'
    script5.async = true
    document.body.appendChild(script5)

    const script7 = document.createElement('script')
    script7.src = 'https://xpay.tosspayments.com/xpay/js/xpay_crossplatform.js'
    script7.async = true
    document.body.appendChild(script7)
  }, [])
  //적립금 관련
  useEffect(() => {
    const acc = formatNumberWithTruncation((Number(orderPrice?.cartAmt || 0) - Number(unPrice)) * 0.1)
    if (Number(acc.replaceAll(',', '')) <= 0) {
      setDiscoutAcc(0)
    } else {
      setDiscoutAcc(Number(acc?.replaceAll(',', '')))
    }
  }, [orderPrice, unPrice])
  //쿠폰적용
  useEffect(() => {
    if (hasAccessToken) {
      //@ts-ignore
      getSubmitCoupons(params.orderSheetNo)
        .then((res) => {
          const array: any = []
          setCartCoupons(res.data.cartCoupons)
        })
        .catch((err) => console.log(err))
    }
  }, [])

  useEffect(() => {
    if (cartCoupon || productCoupon) {
      const obj: any = {
        cartCouponIssueNo: cartCoupon,
        channelType: null,
        promotionCode: null,
        productCoupons: productCoupon,
      }
      setSelectCoupons(obj)
    }
  }, [productCoupon, cartCoupon])

  useEffect(() => {
    if (hasAccessToken) {
      getBookedAddresses().then((res) => {})
      getProfile().then((res) => {
        const address = JSON.parse(res.data.additionalInfo)
        setBaseAddress(address)
        setPhone(res.data.mobileNo)
        setEmail(res.data.email)
        setReceivePhone(res.data.mobileNo)
      })
    }
  }, [])

  // 기본 배송지있으면 그걸로 매칭
  useEffect(() => {
    if (modalSelectAddress !== undefined) {
      setReceiveZip(modalSelectAddress.receiverZipCd)
      setReceiveAddress_1(modalSelectAddress.receiverAddress)
      setReceiveAddress_2(modalSelectAddress.receiverDetailAddress)
      setReceiverJibun(modalSelectAddress.receiverJibunAddress)
      setReceiveName(modalSelectAddress?.receiverName ? modalSelectAddress?.receiverName : '')
      setReceiveMobile(modalSelectAddress?.receiverContact2.replaceAll('-', ''))
      setReceivePhone(modalSelectAddress?.receiverContact1.replaceAll('-', ''))
      setIsCheckboxSameOrder(false)
    } else {
      if (!defaultAddress) {
        setReceiveZip(baseAddress.zipCd)
        setReceiveAddress_1(baseAddress.address)
        setReceiveAddress_2(baseAddress.detailAddress)
      }
    }
  }, [modalSelectAddress, baseAddress])
  //어바웃피싱 페이 조회
  useEffect(() => {
    if (hasAccessToken) {
      getPaymentInfo()
        .then((res) => {
          setCardInfo(res.data.paymentInfos)
          setPayUserRegister(res.data.resultCode)
          setIsLottie(false)
          setNomember(false)
        })
        .catch((res) => {
          // console.log(res.response.data);
          setNomember(true)
          setPayUserRegister(res.response.data.code)
          // setIsLottie(false);
        })
    }
  }, [cardDelete, changePop])

  // 어바웃피싱 페이 css 데이터
  useEffect(() => {
    if (myPayData) {
      window.localStorage.setItem('myPayData', JSON.stringify(myPayData))
    }
  }, [myPayData])

  useEffect(() => {
    if (hasAccessToken) {
      getProfile()
        .then((res) => {
          const imageUrl = JSON.parse(res.data.additionalInfo)
          setUserData(res.data)
        })
        .catch((err) => console.log(err))
    }
    if (hasAccessToken) {
      postSupportCoin('total')
        .then((res) => {
          setFishingCoin(res.data.totalCoin)
        })
        .catch((err) => {
          if (err.status === 401) {
            const refresh = getParsedLocalStorageItem('aboutRefreshToken')
            const os = getParsedSessionStorageItem('os')
            handleAccessToken(refresh, os)
          }
        })
    }
  }, [pointChange])
  useEffect(() => {
    if (hasAccessToken) {
      getAccumulations('ADD')
        .then((res) => {
          setAccumulation(res.data.totalAmt)
        })
        .catch((err) => console.log(err))
    }
  }, [pointChange])

  useEffect(() => {
    if (location.state?.acc && orderPrice && accumulation) {
      const allAcc = formatNumberWithTruncation(orderPrice.paymentAmt * 0.1)
      if (Number(accumulation) < Number(allAcc?.replaceAll(',', ''))) {
        if (Number(accumulation) === Number(location.state?.acc)) {
          setIsCheckboxAllPoint(true)
        }
      } else {
        if (Number(allAcc?.replaceAll(',', '')) === Number(location.state?.acc)) {
          setIsCheckboxAllPoint(true)
        }
      }
    }
  }, [location, orderPrice, accumulation])

  function getItem() {
    //@ts-ignore
    getOrderSheet(params.orderSheetNo)
      .then((res) => {
        setOrderItem(res.data.deliveryGroups[0].orderProducts)
        setOrderPrice(res.data.paymentInfo)
        setMyPayData(res.data.myPayInfo)
        setIsLottie(false)
      })
      .catch((err) => console.log(err))
  }

  const handleComplete = (data: any) => {
    let fullAddress = data.address
    let extraAddress = ''

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : ''
    }
    setReceiveZip(data.zonecode)
    setReceiveAddress_1(data.address)
    setReceiverJibun(data.jibunAddress)
    setVisible(false)
    postShippingInfo()
  }

  const postShippingInfo = () => {
    const cartList = getParsedLocalStorageItem('cartlist')
    let cartArray: any = []
    const pixelContent_ids: number[] = []
    const pixelContents: { name: string; quantity: number }[] = []
    if (selectCategorys.length !== 0) {
      const orderArray = orderItem.flatMap((el: any, idx: number) => {
        return el.orderProductOptions.map((option: any) => {
          pixelContent_ids.push(el?.productNo)
          pixelContents.push({ name: el?.productName, quantity: option.orderCnt })
          return {
            item_id: String(el?.productNo),
            item_name: el?.productName,
            affiliation: '어바웃피싱',
            item_list_price: option.price?.salePrice,
            item_selling_price: option.price?.salePrice - option.price?.immediateDiscountAmt,
            price: option.price?.salePrice - option.price?.immediateDiscountAmt,
            item_total_discount: option.price?.immediateDiscountAmt,
            discount: 0,
            coupon: undefined,
            index: 0,
            item_brand: el.brandName,
            quantity: option.orderCnt,
            item_category: selectCategorys[idx]?.depth1Label,
            item_category2: selectCategorys[idx]?.depth2Label,
            item_category3: selectCategorys[idx]?.depth3Label,
            item_variant: option.optionTitle,
            item_list_id: undefined,
            item_list_name: undefined,
            promotion_id: undefined,
            promotion_name: undefined,
          }
        })
      })
      if (cartList.length !== 0) {
        cartList.map((element: any) => {
          for (let i = 0; i < orderArray.length; i++) {
            if (element.product == orderArray[i].item_id) {
              orderArray[i].item_list_id = element.item_list_id
              orderArray[i].item_list_name = element.item_list_name
              orderArray[i].promotion_id = element.promotion_id
              orderArray[i].promotion_name = element.promotion_name
              cartArray.push(orderArray[i])
            }
          }
        })
      } else {
        cartArray = orderArray
      }
      addPaymentInfo(pixelContent_ids, pixelContents as [{ name: string; quantity: number }], orderPrice?.cartAmt || 0)
      const viewItem: DataLayerArgs = {
        dataLayer: {
          event: 'add_shipping_info',
          ecommerce: {
            currency: 'KRW',
            value: orderPrice?.cartAmt,
            items: cartArray,
            pay_back: orderPrice?.accumulationAmtWhenBuyConfirm,
            reserve_discount: submitAcc,
          },
        },
      }
      if (isAppView) {
        sendSetAppsflyerEvent({
          eventName: 'add_shipping_info',
          eventType: {
            currency: 'KRW',
            value: orderPrice?.cartAmt,
            items: cartArray,
            pay_back: orderPrice?.accumulationAmtWhenBuyConfirm,
            reserve_discount: submitAcc,
          },
        })
      } else {
        TagManager.dataLayer(viewItem)
      }
    }
  }

  useEffect(() => {
    if (defaultAddress.length !== 0) {
      postShippingInfo()
    }
  }, [defaultAddress, selectCategorys])

  useEffect(() => {
    const array: any = []
    const cartList = getParsedLocalStorageItem('cartlist')
    let cartArray: any = []
    if (selectCategorys.length !== 0) {
      orderItem.map((el: any, idx: number) => {
        el.orderProductOptions.map((element: any) => {
          const obj = {
            item_id: String(el?.productNo),
            item_name: el?.productName,
            affiliation: '어바웃피싱',
            item_list_price: element.price?.salePrice,
            item_selling_price: element.price?.salePrice - element.price?.immediateDiscountAmt,
            price: element.price?.salePrice - element.price?.immediateDiscountAmt,
            item_total_discount: element.price?.immediateDiscountAmt,
            discount: 0,
            coupon: undefined,
            index: 0,
            item_brand: el.brandName,
            quantity: element.orderCnt,
            item_category: selectCategorys[idx]?.depth1Label,
            item_category2: selectCategorys[idx]?.depth2Label,
            item_category3: selectCategorys[idx]?.depth3Label,
            item_variant: element.optionTitle,
            item_list_id: undefined,
            item_list_name: undefined,
            promotion_id: undefined,
            promotion_name: undefined,
          }
          array.push(obj)
        })
      })

      if (cartList.length !== 0) {
        cartList.forEach((element: any) => {
          array.forEach((item: any) => {
            if (element.product === item.item_id) {
              item.item_list_id = element.item_list_id
              item.item_list_name = element.item_list_name
              item.promotion_id = element.promotion_id
              item.promotion_name = element.promotion_name
            }
          })
        })

        // Step 2: array의 모든 항목을 cartArray에 추가
        array.forEach((item: any) => {
          cartArray.push(item)
        })
      } else {
        cartArray = array
      }

      const viewItem: DataLayerArgs = {
        dataLayer: {
          event: 'begin_checkout',
          ecommerce: {
            currency: 'KRW',
            value: orderPrice?.cartAmt,
            items: cartArray,
            pay_back: orderPrice?.accumulationAmtWhenBuyConfirm,
            reserve_discount: location.state?.acc || 0,
          },
        },
      }
      if (isAppView) {
        sendSetAppsflyerEvent({
          eventName: 'begin_checkout',
          eventType: {
            currency: 'KRW',
            value: orderPrice?.cartAmt,
            items: cartArray,
            pay_back: orderPrice?.accumulationAmtWhenBuyConfirm,
            reserve_discount: location.state?.acc || 0,
          },
        })
      } else {
        TagManager.dataLayer(viewItem)
      }
    }
  }, [orderItem, selectCategorys])

  useEffect(() => {
    if (hasAccessToken) {
      if (receiverJibun || selectCoupons) {
        if (params.orderSheetNo !== undefined) {
          postUserAddressCalculate(
            params.orderSheetNo,
            receiveZip,
            receiveAddress_1,
            receiveAddress_2,
            receiverJibun,
            selectCoupons
          )
            .then((res) => {
              setOrderPrice(res.data.paymentInfo)
            })
            .catch((res) => {
              console.log(res.data)
            })
        }
      }
    } else {
      if (receiverJibun || selectCoupons) {
        if (params.orderSheetNo !== undefined) {
          postGuestAddressCalculate(params.orderSheetNo, receiveZip, receiveAddress_1, receiveAddress_2, receiverJibun)
            .then((res) => {
              setOrderPrice(res.data.paymentInfo)
            })
            .catch((res) => {
              console.log(res.data)
            })
        }
      }
    }
  }, [receiverJibun, selectCoupons])
  //어바웃 피싱 페이 함수
  useEffect(() => {
    const handleMessage = (event: any) => {
      // 보안 체크: 새 창의 도메인 확인
      if (event.origin !== process.env.REACT_APP_SHOP_URL) return
      if (event.data.update) {
        setTimeout(() => {
          setChangePop((prev: any) => {
            return !prev
          })
        }, 1000)
      }

      // 받은 URL을 처리하는 로직 추가
    }
    setTimeout(() => {
      window.addEventListener('message', handleMessage)
    }, 500)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  //어바웃피싱 페이 카드등록
  useEffect(() => {
    if (hasExecuted.current) return // 이미 실행됐으면 return
    hasExecuted.current = true // 첫 실행 이후에는 실행하지 않음

    const handleMessage = (event: any) => {
      if (event.origin !== process.env.REACT_APP_SHOP_URL) return

      if (event.data.date) {
        setTimeout(() => {
          setChangePop((prev: any) => !prev)
        }, 1000)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  //어바웃 피싱 페이 결제완료
  useEffect(() => {
    const handleMessage = (event: any) => {
      // 보안 체크: 새 창의 도메인 확인
      if (event.origin !== process.env.REACT_APP_SHOP_URL) return
      if (event.data.url && event.data.payType) {
        const result = event.data.url?.split('?')
        navigate(`/orderFinish?${result[1]}&paytype=${event.data.payType}`)
      }
      // 받은 URL을 처리하는 로직 추가
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])
  //주문자와 동일
  useEffect(() => {
    if (isCheckboxSameOrder && name && phone) {
      setReceiveName(name)
      setReceivePhone(phone)
    }
    postShippingInfo()
  }, [isCheckboxSameOrder])

  useEffect(() => {}, [discoutAcc])
  // //주문서에서 다른 탭으로 이동하려할때
  // useEffect(() => {
  //   const handleBackButton = (event: any) => {
  //     event.preventDefault();
  //     const confirmMessage = '작성중인 내용은 저장되지 않습니다. 주문을 취소하시겠습니까?';
  //     if (window.confirm(confirmMessage)) {
  //       window.history.back(); // 뒤로 가기 수행
  //     }
  //   };

  //   window.onpopstate = handleBackButton;
  //   return () => {
  //     window.onpopstate = null; // 이후에는 뒤로가기 이벤트를 무시합니다.
  //   };
  // }, []);

  const totalAmount = Math.max(
    0,
    (orderPrice?.productAmt || 0) -
      submitAcc -
      (orderPrice?.productCouponAmt || 0) +
      (orderPrice?.deliveryAmt || 0) -
      (orderPrice?.cartCouponAmt || 0)
  )

  const paymentAmount = (orderPrice?.paymentAmt || 0) - submitAcc < 0 ? 0 : (orderPrice?.paymentAmt || 0) - submitAcc

  return (
    <>
      <div className='main_wrap'>
        <div className='contents_wrap'>
          <PageTitle>주문하기</PageTitle>
          <div className='order_wrap'>
            <div className='left_area'>
              <Hr8></Hr8>
              <SectionDiv>
                <SectionTitle>주문자 정보</SectionTitle>
                <InputTextSection>
                  <InputTextDiv>
                    <InputTextTitle>주문자</InputTextTitle>
                    <InputText
                      ref={orderNameRef}
                      placeholder='성함을 입력해 주세요.'
                      value={name}
                      onChange={(e: any) => {
                        setName(e.target.value)
                      }}
                    ></InputText>
                  </InputTextDiv>
                  <InputTextDiv>
                    <InputTextTitle>휴대폰 번호</InputTextTitle>
                    <InputText
                      ref={orderPhoneRef}
                      placeholder='‘-’을 제외하고 입력해 주세요.'
                      value={phone?.replaceAll('-', '')}
                      onChange={(e: any) => {
                        setPhone(e.target.value)
                      }}
                    ></InputText>
                  </InputTextDiv>
                  <InputTextDiv>
                    <InputTextTitle>이메일</InputTextTitle>
                    <InputText
                      ref={orderEmailRef}
                      placeholder='이메일을 입력해 주세요.'
                      value={email}
                      onChange={(e: any) => {
                        setEmail(e.target.value)
                      }}
                    ></InputText>
                  </InputTextDiv>
                  {hasAccessToken ? null : (
                    <>
                      <InputTextDiv>
                        <InputTextTitle>비밀번호</InputTextTitle>
                        <InputText
                          ref={orderPasswordRef}
                          type={'password'}
                          placeholder='비밀번호를 입력해 주세요.'
                          onChange={(e: any) => {
                            setPassword(e.target.value)
                          }}
                        ></InputText>
                      </InputTextDiv>
                      <InputTextDiv>
                        <InputTextTitle>비밀번호 확인</InputTextTitle>
                        <TextWrap>
                          <InputText
                            ref={orderPasswordCheckRef}
                            type={'password'}
                            placeholder='비밀번호를 입력해 주세요.'
                            onChange={(e: any) => {
                              setRepassword(e.target.value)
                              if (password === e.target.value && password.length !== 0) {
                                setPasswordCheck(false)
                              } else {
                                setPasswordCheck(true)
                              }
                            }}
                          ></InputText>
                        </TextWrap>
                      </InputTextDiv>
                      <InputTextDiv>
                        <InputTextTitle></InputTextTitle>
                        <p
                          style={{
                            color: passwordCheck ? 'red' : '#898989',
                            fontSize: 12,
                            fontWeight: 500,
                            lineHeight: '16px',
                          }}
                        >
                          {passwordCheck && password
                            ? '비밀번호를 다시 확인 해주세요.'
                            : '영문, 숫자, 특수문자 조합 8자 이상'}
                        </p>
                      </InputTextDiv>
                    </>
                  )}
                </InputTextSection>
              </SectionDiv>
              <Hr8></Hr8>
              <SectionDiv>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 20,
                  }}
                >
                  <SectionTitle style={{ margin: 0 }}>배송지 정보</SectionTitle>
                  {hasAccessToken ? (
                    <BtnWhiteRounded
                      style={{ marginLeft: 'auto' }}
                      onClick={() => {
                        setRecentModal(true)
                      }}
                    >
                      최근 배송지
                    </BtnWhiteRounded>
                  ) : null}
                </div>
                <InputTextSection>
                  <InputCheckbox
                    text={'주문자 동일'}
                    isCheckbox={isCheckboxSameOrder}
                    setIsCheckbox={setIsCheckboxSameOrder}
                  ></InputCheckbox>

                  <InputTextDiv>
                    <InputTextTitle>받으시는 분</InputTextTitle>
                    <InputText
                      ref={deliveryNameRef}
                      placeholder='성함을 입력해 주세요.'
                      onChange={(e: any) => {
                        setReceiveName(e.target.value)
                      }}
                      value={receiveName}
                    ></InputText>
                  </InputTextDiv>
                  <InputTextDiv>
                    <InputTextTitle style={{ alignSelf: 'start', marginTop: 10 }}>주소</InputTextTitle>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        gap: 8,
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '8px',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            gap: '8px',
                            justifyContent: 'space-between',
                          }}
                        >
                          <input
                            ref={deliveryAddressRef}
                            type='text'
                            id='address_1'
                            name='address_1'
                            readOnly
                            value={receiveZip}
                            style={{
                              fontSize: '14px',
                              fontWeight: '500',
                              lineHeight: '20px',
                              color: 'var(--colGray6)',
                              padding: '10px 14px',
                              borderRadius: '5px',
                              border: '1px solid var(--colGray3)',
                              backgroundColor: 'var(--colGray1)',
                              width: 'calc(100% - 110px)',
                            }}
                          />
                          <button
                            type='button'
                            id='address_btn'
                            onClick={() => {
                              setVisible(true)
                            }}
                            style={{
                              fontSize: '13px',
                              fontWeight: '500',
                              lineHeight: '16px',
                              color: 'var(--colWhite)',
                              padding: '12px 14px',
                              borderRadius: '5px',
                              maxWidth: '100px',
                              width: '102px',
                              backgroundColor: 'var(--colBlack)',
                              border: '0',
                              fontFamily: 'Pretendard, sans-serif',
                            }}
                          >
                            우편번호 찾기
                          </button>
                        </div>
                        <input
                          type='text'
                          id='address_2'
                          name='address_2'
                          readOnly
                          value={receiveAddress_1}
                          style={{
                            fontSize: '14px',
                            fontWeight: '500',
                            lineHeight: '20px',
                            color: 'var(--colGray6)',
                            padding: '10px 14px',
                            width: '100%',
                            borderRadius: '5px',
                            border: '1px solid var(--colGray3)',
                            backgroundColor: 'var(--colGray1)',
                          }}
                        />
                      </div>
                      <input
                        ref={deliveryAddressDetailRef}
                        type='text'
                        id='address_3'
                        name='address_3'
                        placeholder='상세주소를 입력해주세요'
                        value={receiveAddress_2}
                        style={{
                          fontSize: '14px',
                          fontWeight: '500',
                          lineHeight: '24px',
                          color: 'var(--colBlack)',
                          padding: '8px 16px',
                          width: '100%',
                          borderRadius: '5px',
                          border: isFocus ? '1px solid var(--colBlack)' : '1px solid var(--colGray3)',
                          backgroundColor: 'var(--colWhite)',
                        }}
                        onChange={(e) => {
                          setReceiveAddress_2(e.target.value)
                        }}
                        onFocus={(e) => setIsFocus(true)}
                        onBlur={(e) => setIsFocus(false)}
                      />
                    </div>
                  </InputTextDiv>
                  <InputTextDiv>
                    <InputTextTitle>휴대폰 번호</InputTextTitle>
                    <InputText
                      ref={deliveryPhoneRef}
                      type='number'
                      placeholder='‘-’을 제외하고 입력해 주세요.'
                      onChange={(e: any) => {
                        setReceivePhone(e.target.value)
                      }}
                      value={receivePhone?.replaceAll('-', '')}
                    ></InputText>
                  </InputTextDiv>
                  {/* <InputTextDiv>
                    <InputTextTitle>전화번호</InputTextTitle>
                    <InputText
                      ref={deliveryTelRef}
                      type='number'
                      placeholder='‘-’을 제외하고 입력해 주세요.'
                      onChange={(e: any) => {
                        setReceiveMobile(e.target.value);
                      }}
                      value={receiveMobile.replaceAll('-', '')}
                    ></InputText>
                  </InputTextDiv> */}
                  <InputTextDiv>
                    <InputTextTitle style={{ alignSelf: 'start', marginTop: 10 }}>배송 메시지</InputTextTitle>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        gap: 8,
                      }}
                    >
                      <Dropdown setReceiverMemo={setReceiverMemo} data={deliveryMemo}></Dropdown>
                      {receiveMemo === '직접 입력' ? (
                        <InputTextArea
                          ref={receiveMemoCustomRef}
                          placeholder='요청사항을 입력해 주세요. (30자 이내)'
                          maxLength={30}
                        ></InputTextArea>
                      ) : null}
                    </div>
                  </InputTextDiv>
                </InputTextSection>
              </SectionDiv>
              <Hr8></Hr8>
              <SectionDiv>
                <SectionTitle>주문 상품 내역</SectionTitle>
                <div className='order_item_list'>
                  {orderItem?.map((element: any, idx: number) => {
                    return (
                      <ProductItems
                        key={idx}
                        el={element}
                        element={element}
                        categorys={categorys}
                        idx={idx}
                        setIsModal={setIsModal}
                        setSelectCoupon={setSelectCoupon}
                        orderItem={orderItem}
                        selectCoupon={selectCoupon}
                        isModal={isModal}
                        productCoupon={productCoupon}
                        setProductCoupon={setProductCoupon}
                        couponText={couponText}
                        setCouponText={setCouponText}
                        setSelectCategorys={setSelectCategorys}
                      ></ProductItems>
                    )
                  })}
                </div>
              </SectionDiv>
              <Hr8></Hr8>
              {hasAccessToken ? (
                <>
                  <div className='order_coupon_wrap'>
                    <div className='order_coupon_title'>
                      <SectionTitle style={{ marginBottom: '0' }}> 주문 쿠폰</SectionTitle>
                      {cartCoupons.length !== 0 ? (
                        <BtnBlack
                          className='btn_order_coupon'
                          onClick={() => {
                            setCartCouponModal(true)
                          }}
                        >
                          {cartCouponTitle ? '쿠폰 변경' : '쿠폰 선택'}
                        </BtnBlack>
                      ) : null}
                    </div>
                    {cartCouponTitle ? null : <div className='no_order_coupon'>적용된 주문 쿠폰이 없습니다.</div>}
                    {cartCouponTitle ? (
                      <>
                        <TooltipCartCouponOrder
                          content={cartCouponTitle}
                          setCartCoupon={setCartCoupon}
                          setTitle={setCartCouponTitle}
                        ></TooltipCartCouponOrder>
                      </>
                    ) : null}
                  </div>
                  <Hr8></Hr8>
                  {cartCouponModal ? (
                    isMobile ? (
                      <OldOrderCartCouponModal
                        setIsModal={setCartCouponModal}
                        setCartCoupon={setCartCoupon}
                        setCartCoupons={setCartCoupons}
                        cartCoupon={cartCoupon}
                        setSelectCoupons={setSelectCoupons}
                        //@ts-ignore
                        orderSheetNo={params.orderSheetNo}
                        setTitle={setCartCouponTitle}
                      ></OldOrderCartCouponModal>
                    ) : (
                      <OrderCartCouponCenterModal
                        setIsModal={setCartCouponModal}
                        setCartCoupon={setCartCoupon}
                        cartCoupon={cartCoupon}
                        //@ts-ignore
                        orderSheetNo={params.orderSheetNo}
                        setTitle={setCartCouponTitle}
                      ></OrderCartCouponCenterModal>
                    )
                  ) : null}
                </>
              ) : null}
              {hasAccessToken ? (
                <>
                  <SectionDiv className='point_container'>
                    <SectionTitle>적립금 전환</SectionTitle>

                    <div className='point_transform_wrap'>
                      {/* 적립금 전환 */}

                      {/* 피싱코인 */}
                      <div className='fishing_coin'>
                        {/* 피싱코인 숫자 */}
                        <div className='coin_num'>
                          <p>{fishingCoin ? plusComma(fishingCoin) : 0}</p>
                          <img src='/images/icon_coin.png' alt='coin'></img>
                        </div>
                        {/* 피싱코인 텍스트 */}
                        <div className='coin_text'>
                          <p>피싱코인</p>
                        </div>
                      </div>

                      {/* 전환 버튼 */}
                      <button
                        className='btn_transform'
                        onClick={() => {
                          setPointModal(true)
                        }}
                      >
                        전환
                      </button>

                      {/* 적립금 */}
                      <div className='point'>
                        {isMobile ? (
                          // 모바일
                          <>
                            <div className='point_num'>
                              <p>{plusComma(accumulation)}</p>
                              <img src='/images/icon_point.png' alt='coin' />
                            </div>
                            <div className='point_text'>
                              <p>적립금</p>
                            </div>
                          </>
                        ) : (
                          // PC
                          <>
                            <div className='point_num'>
                              <p>{plusComma(accumulation)}</p>
                              <img src='/images/icon_point.png' alt='coin' />
                            </div>
                            <div className='point_text'>
                              <p>적립금</p>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    {/* 내 보유 적립금, 사용 가능 적립금 */}
                    <div className='point_status'>
                      <div className='my_point'>
                        <p className='my_point_text'>내 보유 적립금</p>
                        <div className='my_point_num'>
                          <p>{formatNumberWithTruncation(accumulation)}</p>
                          <img src='/images/icon_point.png' alt='coin' />
                        </div>
                      </div>
                      <div className='available_point'>
                        <p>사용 가능 적립금</p>
                        <div className='available_point_num'>
                          <p>
                            {/*@ts-ignore */}
                            {discoutAcc < accumulation
                              ? plusComma(discoutAcc)
                              : formatNumberWithTruncation(accumulation)}
                          </p>
                          <img src='/images/icon_point.png' alt='coin' />
                        </div>
                      </div>
                    </div>

                    {/* 적립금 변환 Input */}
                    <div className='point_exchange_container'>
                      <div className='input_wrap'>
                        <InputText
                          defaultValue={0}
                          type='text'
                          inputMode='numeric'
                          value={inputAcc === 0 ? '' : plusComma(Number(inputAcc))}
                          placeholder='0'
                          disabled={accumulation === 0 || discoutAcc === 0}
                          onChange={(e) => {
                            setInputAcc(
                              Number(
                                e.target.value
                                  .replace(/,/g, '')
                                  .replace(/-/g, '')
                                  .replace(/[^0-9]/g, '')
                              )
                            )
                            setCheckBtn(false)
                            setIsCheckboxAllPoint(false)
                            if (
                              Number(
                                e.target.value
                                  .replace(/,/g, '')
                                  .replace(/-/g, '')
                                  .replace(/[^0-9]/g, '')
                              ) >= Number(discoutAcc + 1) ||
                              Number(
                                e.target.value
                                  ?.replace(/,/g, '')
                                  ?.replace(/-/g, '')
                                  .replace(/[^0-9]/g, '')
                              ) > Number(accumulation)
                            ) {
                              alert('사용 적립금 이상으로 사용할 수 없습니다.')
                              if (discoutAcc >= accumulation) {
                                const acc = formatNumberWithTruncation(accumulation)
                                setInputAcc(Number(acc.replaceAll(',', '')))
                              } else {
                                setInputAcc(discoutAcc)
                              }
                            }
                          }}
                        ></InputText>
                        {inputAcc ? (
                          <button
                            type='button'
                            className='pointReset'
                            onClick={() => {
                              setInputAcc(0)
                              setSubmitAcc(0)
                              setIsCheckboxAllPoint(false)
                              setCheckBtn(false)
                            }}
                          ></button>
                        ) : null}
                      </div>
                      {!checkBtn ? (
                        <BtnBlack
                          className='btn_point_apply'
                          onClick={() => {
                            if (Number(inputAcc) % 1000 === 0) {
                              if (Number(inputAcc) !== 0) {
                                setSubmitAcc(inputAcc)
                                setCheckBtn(true)
                                setIsToast(true)
                                setToastMessage('적립금 적용을 완료했습니다.')
                              }
                            } else {
                              alert('1000원 단위로 사용가능합니다.')
                              setInputAcc(0)
                              setSubmitAcc(0)
                            }
                          }}
                        >
                          적용하기
                        </BtnBlack>
                      ) : (
                        <BtnBlack
                          className='btn_point_apply'
                          style={{
                            color: 'var(--colGray4)',
                            background: 'var(--colGray2)',
                          }}
                        >
                          적용하기
                        </BtnBlack>
                      )}
                    </div>

                    {accumulation !== 0 && discoutAcc !== 0 ? (
                      <div
                        className='all_apply'
                        onClick={() => {
                          const limitAcc = formatNumberWithTruncation(priceItem?.totalAmt * 0.1)

                          if (!isCheckboxAllPoint) {
                            if (accumulation !== 0 && formatNumberWithTruncation(priceItem?.totalAmt * 0.1) !== '0') {
                              if (discoutAcc < accumulation) {
                                setSubmitAcc(discoutAcc)
                                setInputAcc(discoutAcc)
                                setIsCheckboxAllPoint(true)
                                setCheckBtn(true)
                              } else if (discoutAcc > accumulation) {
                                const acc = formatNumberWithTruncation(accumulation)
                                setSubmitAcc(Number(acc.replaceAll(',', '')))
                                setInputAcc(Number(acc.replaceAll(',', '')))
                                setIsCheckboxAllPoint(true)
                                setCheckBtn(true)
                              }
                            } else {
                              setIsCheckboxAllPoint(false)
                              setCheckBtn(false)
                              setSubmitAcc(0)
                              setInputAcc(0)
                            }
                          } else {
                            setIsCheckboxAllPoint(false)
                            setCheckBtn(false)
                            setSubmitAcc(0)
                            setInputAcc(0)
                          }
                        }}
                      >
                        <InputCheckbox
                          text={'모두 적용'}
                          isCheckbox={isCheckboxAllPoint}
                          setIsCheckbox={setIsCheckboxAllPoint}
                          fontSize={isMobile ? 13 : 14}
                        ></InputCheckbox>
                      </div>
                    ) : (
                      <div
                        className='all_apply_wrap'
                        onClick={() => {
                          if (accumulationUsable?.length === orderItem?.length) {
                            alert('적립금을 사용할 수 없는 상품입니다.')
                          }
                        }}
                      >
                        <img src='/images/icon_checkbox_false.svg' alt='checkbox' />
                        <p>{'모두 적용'}</p>
                      </div>
                    )}
                  </SectionDiv>
                  <Hr8></Hr8>
                </>
              ) : null}
              <SectionDiv
                style={{
                  padding: isMobile ? '24px 0px' : '32px 0px',
                  // marginTop: isMobile ? '0px' : '32px',
                  // borderTop: isMobile ? 'none' : '1px solid var(--colGray3)',
                }}
              >
                <SectionTitle
                  style={{
                    padding: isMobile ? '0 20px' : '0px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    position: 'relative',
                  }}
                >
                  <p>결제 수단</p>
                </SectionTitle>

                {/* 카카오페이 */}
                <div className='pay_method_wrap'>
                  {hasAccessToken
                    ? payArray.map((el: any) => {
                        if (el === '어바웃피싱 페이') {
                          if (!hasAccessToken) {
                            return null
                          } else {
                            return (
                              <>
                                <div
                                  className='pay_method_cont'
                                  onClick={() => {
                                    setSelectPay(el)
                                  }}
                                >
                                  <div className={`pay_method_cont_inner ${selectPay === el ? 'on' : ''}`}>
                                    {el === '카카오페이' && (
                                      <img
                                        src='/images/icon_kakaopay.png'
                                        alt='카카오페이 아이콘'
                                        className='pay_icon'
                                      />
                                    )}
                                    {el === '네이버페이' && (
                                      <img
                                        src='/images/icon_npay_new.png'
                                        alt='네이버페이 아이콘'
                                        className='pay_icon'
                                      />
                                    )}
                                    {el === '어바웃피싱 페이' && (
                                      <img
                                        src={`${
                                          selectPay === el ? '/images/icon_afpay_w.png' : '/images/icon_afpay.png'
                                        }`}
                                        alt='어바웃피싱 페이 아이콘'
                                        className='pay_icon'
                                      />
                                    )}
                                    <p>{el}</p>
                                    {el === '신용 / 체크카드' && (
                                      <div className='img_box'>
                                        <img src='/images/icon_card3_toss.png' alt='토스페이 아이콘' />
                                        <img src='/images/icon_card1_kb.png' alt='kbpay 아이콘' />
                                        <img src='/images/icon_card2_sh.png' alt='신한페이 아이콘' />
                                        <img src='/images/icon_card4_lpoint.png' alt='l포인트 아이콘' />
                                        <img src='/images/icon_card5_apple.png' alt='애플페이 아이콘' />
                                        <img src='/images/icon_card6_ssg.png' alt='쓱페이 아이콘' />
                                      </div>
                                    )}

                                    {el === '어바웃피싱 페이' ? (
                                      selectPay === '어바웃피싱 페이' ? (
                                        <>
                                          <div className='select_card_wrap'>
                                            <Swiper
                                              modules={[Pagination]}
                                              spaceBetween={12}
                                              slidesPerView={1.17475}
                                              centeredSlides={true}
                                              loop={false}
                                              onSlideChange={(swiper: any) => {
                                                setSlideIdx(swiper.activeIndex)
                                              }}
                                            >
                                              {hasAccessToken &&
                                                cardInfo?.map((el: any) => {
                                                  return (
                                                    <SwiperSlide
                                                      key={el?.cardImgUrl}
                                                      style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        flexWrap: 'wrap',
                                                        gap: '10px',
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          backgroundImage: `url(${el?.cardImgUrl})`,
                                                        }}
                                                      ></div>
                                                    </SwiperSlide>
                                                  )
                                                })}
                                              <SwiperSlide
                                                style={{
                                                  backgroundColor: 'var(--colGray1)',
                                                  borderRadius: 10,
                                                  border: '1px dashed var(--colGray3)',
                                                  padding: '32px 0',
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                  height: 'auto',
                                                }}
                                              >
                                                <img src={`/images/icon_afpay_card.png`} alt='어바웃피싱 페이 로고' />
                                                <p>
                                                  어바웃피싱 페이 등록하고 <br />
                                                  빠르게 결제하세요.
                                                </p>

                                                {payUserRegister !== '0000' ? (
                                                  <BtnBlack
                                                    style={{
                                                      marginTop: 20,
                                                      display: 'flex',
                                                      gap: 4,
                                                      fontSize: '13px',
                                                      fontWeight: 600,
                                                      lineHeight: '16px',
                                                      padding: '10px 16px 10px 10px',
                                                    }}
                                                    onClick={() => {
                                                      if (!isAppView && !isMobile) {
                                                        const option = {
                                                          clientReturnUrl: ` ${process.env.REACT_APP_SHOP_URL}/closet`,
                                                          clientBridgeUrl: `${process.env.REACT_APP_SHOP_URL}/addcard`,
                                                        }

                                                        // @ts-ignore
                                                        if (NCPPay) {
                                                          //@ts-ignore
                                                          NCPPay.setMyPayCssCustom(
                                                            `https://shop-api.e-ncp.com${myPayData?.customCssUrl}`,
                                                            null,
                                                            `${myPayData?.payName}`,
                                                            null
                                                          )
                                                          // @ts-ignore
                                                          NCPPay?.setConfiguration({
                                                            clientId: process.env.REACT_APP_CLIENT_ID, // shopby에서 발급받은 clientId
                                                            confirmUrl: `${process.env.REACT_APP_SHOP_URL}/closet`, // 결과를 리턴받을 url
                                                            platform: isMobile ? 'MOBILE_WEB' : 'PC', // 'PC or MOBILE_WEB or AOS or IOS'
                                                            accessToken: hasAccessToken ? getAccessToken() : '', // 로그인한 사람의 accessToken
                                                            withCredentials: true,
                                                          })
                                                          // @ts-ignore
                                                          NCPPay.requestMyPayApi(option, 'REGISTER_USER_WITH_PAYMENT')
                                                        }
                                                      } else {
                                                        const accesstoken = getParsedLocalStorageItem('accessToken')
                                                        const abouttoken = getParsedLocalStorageItem('aboutAccessToken')
                                                        if (isAppView) {
                                                          handlePostMessage({
                                                            actionType: 'onLink',
                                                            params: {
                                                              url: `${
                                                                process.env.REACT_APP_SHOP_URL
                                                              }/myPayReady?token=${abouttoken}&payLogo=${JSON.stringify(
                                                                myPayData
                                                              )}&accesstoken=${accesstoken}`,
                                                            },
                                                          })
                                                        } else {
                                                          const open = window.open('about:blank', '_blank')
                                                          //@ts-ignore
                                                          open.location.href = `${process.env.REACT_APP_SHOP_URL}/myPayReady?accesstoken=${accesstoken}&app=false`
                                                          // `http://localhost:3000/myPayReady?token=${accesstoken}&app=false&payLogo=${JSON.stringify(
                                                          //   myPayData
                                                          // )}`
                                                        }
                                                      }
                                                    }}
                                                    // }}
                                                  >
                                                    <IconPlus width={16} height={16} color='var(--colWhite)' />
                                                    회원 등록하기
                                                  </BtnBlack>
                                                ) : (
                                                  <BtnBlack
                                                    style={{
                                                      marginTop: 20,
                                                      display: 'flex',
                                                      gap: 4,
                                                      fontSize: '13px',
                                                      fontWeight: 600,
                                                      lineHeight: '16px',
                                                      padding: '10px 16px 10px 10px',
                                                    }}
                                                    onClick={() => {
                                                      if (hasAccessToken) {
                                                        const option = {
                                                          clientReturnUrl: `${process.env.REACT_APP_SHOP_URL}/closet`,
                                                          payMethod: '01',
                                                        }
                                                        // const app = getParsedSessionStorageItem('app')

                                                        if (!isAppView && !isMobile) {
                                                          // @ts-ignore
                                                          if (NCPPay) {
                                                            //@ts-ignore
                                                            NCPPay.setMyPayCssCustom(
                                                              `https://shop-api.e-ncp.com${myPayData?.customCssUrl}`,
                                                              null,
                                                              `${myPayData?.payName}`,
                                                              `${myPayData?.logoImageUrl}`
                                                            )
                                                            // @ts-ignore
                                                            NCPPay?.setConfiguration({
                                                              clientId: process.env.REACT_APP_CLIENT_ID, // shopby에서 발급받은 clientId
                                                              confirmUrl: `${process.env.REACT_APP_SHOP_URL}/closet`, // 결과를 리턴받을 url
                                                              platform: isMobile ? 'MOBILE_WEB' : 'PC', // 'PC or MOBILE_WEB or AOS or IOS'
                                                              accessToken: hasAccessToken ? getAccessToken() : '', // 로그인한 사람의 accessToken
                                                              withCredentials: true,
                                                            })
                                                            // @ts-ignore
                                                            NCPPay.requestMyPayApi(option, 'REGISTER_PAYMENT')
                                                          }
                                                        } else {
                                                          const accesstoken = getParsedLocalStorageItem('accessToken')
                                                          const abouttoken =
                                                            getParsedLocalStorageItem('aboutAccessToken')
                                                          if (isAppView) {
                                                            handlePostMessage({
                                                              actionType: 'onLink',
                                                              params: {
                                                                url: `${
                                                                  process.env.REACT_APP_SHOP_URL
                                                                }/addcard?token=${abouttoken}&payLogo=${JSON.stringify(
                                                                  myPayData
                                                                )}&accesstoken=${accesstoken}`,
                                                              },
                                                            })
                                                          } else {
                                                            const open = window.open('about:blank', '_blank')
                                                            //@ts-ignore
                                                            open.location.href = `${process.env.REACT_APP_SHOP_URL}/addcard?accesstoken=${accesstoken}&app=false`
                                                          }
                                                        }
                                                      } else {
                                                        setIsToast(true)
                                                        setToastMessage('로그인이 필요한 서비스입니다.')
                                                        setToastBtnMessage('로그인')
                                                        setToastEvent(() => () => setIsLogin(true))
                                                      }
                                                    }}
                                                  >
                                                    <IconPlus width={16} height={16} color='var(--colWhite)' />
                                                    카드 등록하기
                                                  </BtnBlack>
                                                )}
                                              </SwiperSlide>
                                            </Swiper>
                                          </div>
                                        </>
                                      ) : null
                                    ) : null}

                                    {el === '어바웃피싱 페이' ? (
                                      selectPay === '어바웃피싱 페이' ? (
                                        payUserRegister === '0000' && hasAccessToken ? (
                                          <button
                                            className='af_option_btn'
                                            onClick={() => {
                                              setIsLayer((prev: boolean) => !prev)
                                            }}
                                          >
                                            {isLayer ? (
                                              <div className='pay_layer'>
                                                <ul>
                                                  <li>
                                                    <button
                                                      className='pay_withdraw'
                                                      onClick={() => {
                                                        const confirmed = window.confirm('탈퇴하시겠습니까?')
                                                        if (confirmed) {
                                                          deleteUserInfo()
                                                            .then((res) => {
                                                              alert('어바웃피싱 페이에서 탈퇴하셨습니다.')
                                                              setCardDelete((prev: boolean) => !prev)
                                                              setChangePop((prev: boolean) => !prev)
                                                              setCardInfo([])
                                                            })
                                                            .catch((err) => {
                                                              console.log(err)
                                                            })
                                                        }
                                                      }}
                                                    >
                                                      페이탈퇴
                                                    </button>
                                                  </li>
                                                  {cardInfo.length === 0 ? null : (
                                                    <li>
                                                      <button
                                                        className='card_delete'
                                                        onClick={() => {
                                                          setDeleteModal((prev: boolean) => !prev)
                                                        }}
                                                      >
                                                        카드삭제
                                                      </button>
                                                    </li>
                                                  )}
                                                </ul>
                                              </div>
                                            ) : null}
                                            <i></i>
                                            <i></i>
                                            <i></i>
                                          </button>
                                        ) : null
                                      ) : null
                                    ) : null}
                                  </div>
                                </div>
                              </>
                            )
                          }
                        }
                        return (
                          <>
                            <div
                              className='pay_method_cont'
                              onClick={() => {
                                setSelectPay(el)
                              }}
                            >
                              <div className={`pay_method_cont_inner ${selectPay === el ? 'on' : ''}`}>
                                {el === '카카오페이' && (
                                  <img src='/images/icon_kakaopay.png' alt='카카오페이 아이콘' className='pay_icon' />
                                )}
                                {el === '네이버페이' && (
                                  <img src='/images/icon_npay_new.png' alt='네이버페이 아이콘' className='pay_icon' />
                                )}
                                <p>{el}</p>
                                {el === '신용 / 체크카드' && (
                                  <div className='img_box'>
                                    <img src='/images/icon_card3_toss.png' alt='토스페이 아이콘' />
                                    <img src='/images/icon_card1_kb.png' alt='kbpay 아이콘' />
                                    <img src='/images/icon_card2_sh.png' alt='신한페이 아이콘' />
                                    <img src='/images/icon_card4_lpoint.png' alt='l포인트 아이콘' />
                                    <img src='/images/icon_card5_apple.png' alt='애플페이 아이콘' />
                                    <img src='/images/icon_card6_ssg.png' alt='쓱페이 아이콘' />
                                  </div>
                                )}
                              </div>
                            </div>

                            {el === '어바웃피싱 페이' ? (
                              selectPay === '어바웃피싱 페이' ? (
                                <>
                                  <div className='select_card_wrap'>
                                    <Swiper
                                      modules={[Pagination]}
                                      spaceBetween={12}
                                      slidesPerView={1.17475}
                                      centeredSlides={true}
                                      loop={false}
                                      onSlideChange={(swiper: any) => {
                                        setSlideIdx(swiper.activeIndex)
                                      }}
                                    >
                                      {hasAccessToken &&
                                        cardInfo?.map((el: any) => {
                                          return (
                                            <SwiperSlide
                                              key={el?.cardImgUrl}
                                              style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexWrap: 'wrap',
                                                gap: '10px',
                                              }}
                                            >
                                              <img
                                                src={el?.cardImgUrl}
                                                alt=''
                                                style={{
                                                  width: '100%',
                                                  height: '100%',
                                                }}
                                              />
                                            </SwiperSlide>
                                          )
                                        })}
                                    </Swiper>
                                  </div>
                                </>
                              ) : null
                            ) : null}
                          </>
                        )
                      })
                    : noMemberArray.map((el: any) => {
                        return (
                          <>
                            <div
                              className='pay_method_cont'
                              onClick={() => {
                                setSelectPay(el)
                              }}
                            >
                              <div className={`pay_method_cont_inner ${selectPay === el ? 'on' : ''}`}>
                                {el === '카카오페이' && (
                                  <img src='/images/icon_kakaopay.png' alt='카카오페이 아이콘' className='pay_icon' />
                                )}
                                {el === '네이버페이' && (
                                  <img src='/images/icon_npay_new.png' alt='네이버페이 아이콘' className='pay_icon' />
                                )}
                                <p>{el}</p>
                                {el === '신용 / 체크카드' && (
                                  <div className='img_box'>
                                    <img src='/images/icon_card3_toss.png' alt='토스페이 아이콘' />
                                    <img src='/images/icon_card1_kb.png' alt='kbpay 아이콘' />
                                    <img src='/images/icon_card2_sh.png' alt='신한페이 아이콘' />
                                    <img src='/images/icon_card4_lpoint.png' alt='l포인트 아이콘' />
                                    <img src='/images/icon_card5_apple.png' alt='애플페이 아이콘' />
                                    <img src='/images/icon_card6_ssg.png' alt='쓱페이 아이콘' />
                                  </div>
                                )}
                              </div>
                            </div>

                            {el === '어바웃피싱 페이' ? (
                              selectPay === '어바웃피싱 페이' ? (
                                <>
                                  <div className='select_card_wrap'>
                                    <Swiper
                                      modules={[Pagination]}
                                      spaceBetween={12}
                                      slidesPerView={1.17475}
                                      centeredSlides={true}
                                      loop={false}
                                      onSlideChange={(swiper: any) => {
                                        setSlideIdx(swiper.activeIndex)
                                      }}
                                    >
                                      {hasAccessToken &&
                                        cardInfo?.map((el: any) => {
                                          return (
                                            <SwiperSlide
                                              key={el?.cardImgUrl}
                                              style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexWrap: 'wrap',
                                                gap: '10px',
                                              }}
                                            >
                                              <img
                                                src={el?.cardImgUrl}
                                                alt=''
                                                style={{
                                                  width: '100%',
                                                  height: '100%',
                                                }}
                                              />
                                            </SwiperSlide>
                                          )
                                        })}
                                    </Swiper>
                                  </div>
                                </>
                              ) : null
                            ) : null}
                          </>
                        )
                      })}
                </div>
              </SectionDiv>
            </div>
            <div className='right_area'>
              <div className='right_area_info'>
                <Hr8></Hr8>
                <SectionDiv
                  style={{
                    paddingTop: isMobile ? '24px' : '0px',
                    paddingBottom: isMobile ? '0px' : '20px',
                  }}
                >
                  <SectionTitle>결제 정보</SectionTitle>
                  <div className='payment_info_wrap'>
                    <ul>
                      {/* 전체 상품 금액 */}
                      <li>
                        <dl>
                          <dt>전체 상품 금액</dt>
                          <dd>{plusComma(orderPrice?.totalStandardAmt)}원</dd>
                        </dl>
                      </li>
                      <li>
                        {/* 할인금액 합계 */}
                        <div className='discount_wrap'>
                          <dl
                            onClick={() => {
                              setOpenDiscount((prev: boolean) => !prev)
                            }}
                          >
                            <dt>
                              할인금액 합계
                              {openDiscount ? (
                                <IconArrowUp width={16} height={16} color='var(--colPointOrange)' />
                              ) : (
                                <IconArrowDown width={16} height={16} color='var(--colPointOrange)' />
                              )}
                            </dt>
                            <dd>
                              -{' '}
                              {plusComma(
                                Number(orderPrice?.totalImmediateDiscountAmt) +
                                  Number(submitAcc) +
                                  Number(orderPrice?.cartCouponAmt) +
                                  Number(orderPrice?.productCouponAmt)
                              )}
                              원
                            </dd>
                          </dl>
                        </div>
                        <ul className={openDiscount ? 'discount_detail_list on' : 'discount_detail_list'}>
                          <li>
                            <dl>
                              <dt>⎿ 상품할인 합계</dt>
                              <dd>
                                -{' '}
                                {plusComma(
                                  (orderPrice?.totalImmediateDiscountAmt || 0) +
                                    (orderPrice?.totalAdditionalDiscountAmt || 0)
                                )}
                                원
                              </dd>
                            </dl>
                          </li>
                          <li>
                            {hasAccessToken ? (
                              <>
                                <dl>
                                  <dt>⎿ 쿠폰할인 합계</dt>
                                  <dd>
                                    -{' '}
                                    {plusComma((orderPrice?.cartCouponAmt || 0) + (orderPrice?.productCouponAmt || 0))}
                                    원
                                  </dd>
                                </dl>
                              </>
                            ) : null}
                          </li>
                          <li>
                            {hasAccessToken ? (
                              <dl>
                                <dt>⎿ 적립금 할인 합계</dt>
                                <dd>- {plusComma(submitAcc)}원</dd>
                              </dl>
                            ) : null}
                          </li>
                        </ul>
                      </li>

                      {/* 배송비 */}
                      <li>
                        <dl>
                          <dt>배송비</dt>
                          <dd>
                            + {plusComma((orderPrice?.deliveryAmt || 0) + (orderPrice?.remoteDeliveryAmt || 0))}원
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </div>
                  <div className='total_infoWrap'>
                    <dl className='total_payment_wrap'>
                      <dt>총 결제 금액</dt>
                      <dd>{plusComma(totalAmount)}원</dd>
                    </dl>
                    {hasAccessToken ? (
                      orderPrice?.accumulationAmtWhenBuyConfirm === 0 ? null : (
                        <p className='mileage'>
                          {' '}
                          구매확정 시 페이백{' '}
                          {selectPayType === 'MY_PAY'
                            ? plusComma(
                                Number(orderPrice?.accumulationAmtWhenBuyConfirm) +
                                  (Number(orderPrice?.totalStandardAmt) -
                                    Number(orderPrice?.totalImmediateDiscountAmt)) *
                                    0.02
                              )
                            : plusComma(Number(orderPrice?.accumulationAmtWhenBuyConfirm))}
                          <img src='/images/icon_won.svg' alt='coin' style={{ width: 14, height: 14 }}></img>
                          적립 예정
                        </p>
                      ) // (
                    ) : //   <dl className='mileage'>
                    //     <dt>예상 적립 마일리지</dt>
                    //     <dd>
                    //       {orderPrice?.accumulationAmtWhenBuyConfirm
                    //         ? plusComma(
                    //             orderPrice?.accumulationAmtWhenBuyConfirm
                    //           )
                    //         : 0}
                    //       원
                    //     </dd>
                    //   </dl>
                    null}
                  </div>
                  <div
                    className='purchase_agree_wrap'
                    style={{
                      position: 'relative',
                    }}
                  >
                    <InputCheckbox
                      text={'구매조건 확인 및 결제 진행 동의'}
                      isCheckbox={isCheckboxPaymentAgree}
                      setIsCheckbox={setIsCheckboxPaymentAgree}
                    ></InputCheckbox>
                    <span
                      style={{
                        opacity: 0,
                        width: '15px',
                        height: '15px',
                        position: 'absolute',
                        right: '0',
                        top: '20%',
                      }}
                    ></span>
                    {hasAccessToken ? null : (
                      <>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <InputCheckbox
                            text={'비회원 주문 개인정보 수집 / 이용 동의'}
                            isCheckbox={isCheckboxNonMember}
                            setIsCheckbox={setIsCheckboxNonMember}
                          ></InputCheckbox>
                          <button
                            onClick={() => {
                              setAgree((prev: boolean) => !prev)
                            }}
                          >
                            보기
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </SectionDiv>
                <div className='purchase_wrap'>
                  <BtnFixed
                    onClick={() => {
                      if (hasAccessToken) {
                        if (name.length === 0) {
                          alert('주문자 성함을 입력해주세요.')
                          orderNameRef.current?.focus()
                          return
                        } else if (phone.length === 0) {
                          alert('주문자 휴대폰 번호를 입력해주세요.')
                          orderPhoneRef.current?.focus()
                          return
                        } else if (isNaN(Number(phone))) {
                          alert('형식에 맞는 휴대폰 번호를 입력해주세요.')
                          orderPhoneRef.current?.focus()
                          return
                        } else if (!/^01[016789]\d{8}$/.test(phone)) {
                          alert('형식에 맞는 휴대폰 번호를 입력해주세요.')
                          orderPhoneRef.current?.focus()
                          return
                        } else if (receiveName.length === 0) {
                          alert('받으시는 분 성함을 입력해주세요.')
                          deliveryNameRef.current?.focus()
                          return
                        } else if (receiveZip.length === 0) {
                          alert('주소를 확인해주세요.')
                          return
                        } else if (receiveAddress_2.length === 0) {
                          alert('상세주소를 입력해주세요.')
                          deliveryAddressDetailRef.current?.focus()
                          return
                        } else if (receivePhone.length === 0) {
                          alert('휴대폰 번호를 입력해주세요')
                          deliveryPhoneRef.current?.focus()
                          return
                        } else if (isNaN(Number(receivePhone))) {
                          alert('받으시는 분 휴대폰 번호를 입력해주세요.')
                          deliveryPhoneRef.current?.focus()
                          return
                        } else if (!/^01[016789]\d{8}$/.test(receivePhone)) {
                          alert('형식에 맞는 휴대폰 번호를 입력해주세요.')
                          deliveryPhoneRef.current?.focus()
                          return
                        } else if (receiveMemo === '직접 입력' && receiveMemoCustomRef.current?.value === '') {
                          alert('배송 메시지를 입력해주세요.')
                          receiveMemoCustomRef.current?.focus()
                          return
                        } else if (!isCheckboxPaymentAgree) {
                          alert('구매조건 확인 및 결제 진행 동의를 해주세요')
                          return
                        }
                        if (betweenArray.length !== 0 && firstpurchase) {
                          alert('100원샵 상품 이용가능 고객이 아닙니다. 장바구니에서 제외 후 구매해주세요.')
                          return
                        }
                        if (cardInfo.length === 0 && selectPayType === 'MY_PAY' && nomember) {
                          alert('어바웃피싱 페이에 등록하지 않았습니다. 등록하거나 다른 결제 수단을 선택해주세요.')
                          return
                        }
                        if (
                          cardInfo.length !== 0 &&
                          selectPayType === 'MY_PAY' &&
                          Number(slideIdx) === Number(cardInfo.length)
                        ) {
                          alert('등록된 카드를 선택해 주세요.')
                          return
                        }
                        if (cardInfo.length === 0 && selectPayType === 'MY_PAY' && !nomember) {
                          alert(
                            '등록된 어바웃피싱 페이 카드가 없습니다. 카드를 등록하거나 다른 결제 수단을 선택해주세요.'
                          )
                          return
                        }
                      } else {
                        if (name.length === 0) {
                          alert('주문자 성함을 입력해주세요.')
                          orderNameRef.current?.focus()
                          return
                        } else if (phone.length === 0) {
                          alert('주문자 휴대폰 번호를 입력해주세요.')
                          orderPhoneRef.current?.focus()
                          return
                        } else if (isNaN(Number(phone))) {
                          alert('형식에 맞는 휴대폰 번호를 입력해주세요.')
                          orderPhoneRef.current?.focus()
                          return
                        } else if (!/^01[016789]\d{8}$/.test(phone)) {
                          alert('형식에 맞는 휴대폰 번호를 입력해주세요.')
                          orderPhoneRef.current?.focus()
                          return
                        } else if (orderEmailRef.current?.value === '') {
                          alert('이메일을 입력해주세요.')
                          orderEmailRef.current?.focus()
                          return
                        } else if (email.length > 0 && !/^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,4}$/.test(email)) {
                          alert('형식에 맞는 이메일을 입력해주세요.')
                          orderEmailRef.current?.focus()
                          return
                        } else if (password.length === 0) {
                          alert('비밀번호를 입력해주세요.')
                          orderPasswordRef.current?.focus()
                          return
                        } else if (
                          password.length > 0 &&
                          !/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/.test(password)
                        ) {
                          alert('비밀번호는 영문, 숫자, 특수문자 조합으로 8자 이상이어야 합니다')
                          orderPasswordRef.current?.focus()
                          return
                        } else if (repassword.length === 0) {
                          alert('비밀번호 확인을 입력해주세요.')
                          orderPasswordCheckRef.current?.focus()
                          return
                        } else if (password !== repassword) {
                          alert('비밀번호를 확인해주세요.')
                          orderPasswordCheckRef.current?.focus()
                          return
                        } else if (receiveName.length === 0) {
                          alert('받으시는 분 성함을 입력해주세요.')
                          deliveryNameRef.current?.focus()
                          return
                        } else if (receiveZip.length === 0) {
                          alert('주소를 확인해주세요.')
                          return
                        } else if (receiveAddress_2.length === 0) {
                          alert('상세주소를 입력해주세요.')
                          deliveryAddressDetailRef.current?.focus()
                          return
                        } else if (receivePhone.length === 0) {
                          alert('받으시는 분 휴대폰 번호를 입력해주세요.')
                          deliveryPhoneRef.current?.focus()
                          return
                        } else if (!/^01[016789]\d{8}$/.test(receivePhone)) {
                          alert('형식에 맞는 휴대폰 번호를 입력해주세요.')
                          deliveryPhoneRef.current?.focus()
                          return
                        } else if (isNaN(Number(receivePhone))) {
                          alert('형식에 맞는 휴대폰 번호를 입력해주세요.')
                          deliveryPhoneRef.current?.focus()
                          return
                        } else if (receiveMemo === '직접 입력' && receiveMemoCustomRef.current?.value === '') {
                          alert('배송 메시지를 입력해주세요.')
                          receiveMemoCustomRef.current?.focus()
                          return
                        } else if (!isCheckboxPaymentAgree) {
                          alert('구매조건 확인 및 결제 진행 동의를 해주세요')
                          return
                        } else if (!isCheckboxNonMember) {
                          alert('비회원 주문 개인정보 수집 / 이용 동의를 해주세요')
                          return
                        }
                        if (!cardInfo[slideIdx]?.payToken && selectPayType === 'MY_PAY') {
                          alert(
                            '등록된 어바웃피싱 페이 카드가 없습니다. 카드를 등록하거나 다른 결제 수단을 선택해주세요.'
                          )
                          return
                        }
                      }
                      const option = {
                        orderSheetNo: params.orderSheetNo,
                        extraData: { productCoupon: couponText, cartCoupon: cartCouponTitle },
                        shippingAddress: {
                          addressNo: 0,
                          receiverZipCd: receiveZip,
                          receiverAddress: receiveAddress_1,
                          receiverJibunAddress: receiverJibun,
                          receiverDetailAddress: receiveAddress_2,
                          receiverName: receiveName,
                          addressName: `${receiveAddress_1} ${receiveAddress_2}`,
                          receiverContact1: receivePhone
                            .replace(/[^0-9]/g, '') // 숫자를 제외한 모든 문자 제거
                            .replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`),
                          receiverContact2: receiveMobile
                            .replace(/[^0-9]/g, '') // 숫자를 제외한 모든 문자 제거
                            .replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`),
                          customsIdNumber: '',
                          countryCd: 'KR',
                          usesShippingInfoLaterInput: false,
                          shippingInfoLaterInputContact: null,
                          requestShippingDate: null,
                          receiverCity: null,
                          receiverState: null,
                          receiverFirstName: null,
                          receiverLastName: null,
                          orderAdditionalInfo: null,
                        },
                        coupons: {
                          cartCouponIssueNo: cartCoupon ? cartCoupon : null,
                          productCoupons: productCoupon,
                        },
                        useDefaultAddress: false,
                        saveAddressBook: true,
                        orderMemo: '',
                        deliveryMemo: receiveMemo,
                        member: false,
                        orderer: {
                          ordererName: name,
                          ordererEmail: '',
                          ordererContact1: phone
                            .replace(/[^0-9]/g, '') // 숫자를 제외한 모든 문자 제거
                            .replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`),
                          ordererContact2: '',
                        },
                        updateMember: false,
                        tempPassword: password ? password : null,
                        subPayAmt: submitAcc,
                        orderTitle: '',
                        pgType: selectPayType === 'CREDIT_CARD' ? 'INICIS' : selectPayType,
                        payType:
                          selectPayType === 'NAVER_EASY_PAY'
                            ? 'NAVER_EASY_PAY'
                            : selectPayType === 'KAKAO_PAY'
                            ? 'KAKAO_PAY'
                            : 'CREDIT_CARD',
                        agreementTermsAgrees: [
                          { isAgree: isCheckboxPaymentAgree, termsType: 'USE' },
                          {
                            isAgree: isCheckboxPaymentAgree,
                            termsType: 'PI_COLLECTION_AND_USE_ON_ORDER',
                          },
                          {
                            isAgree: isCheckboxPaymentAgree,
                            termsType: 'PI_SELLER_PROVISION',
                          },
                          {
                            isAgree: isCheckboxPaymentAgree,
                            termsType: 'CLEARANCE_INFO_COLLECTION_AND_USE',
                          },
                          {
                            isAgree: isCheckboxPaymentAgree,
                            termsType: 'ORDER_INFO_AGREE',
                          },
                          {
                            isAgree: isCheckboxPaymentAgree,
                            termsType: 'ORDER_DEFAULT',
                          },
                          /* USE: 이용약관, PI_COLLECTION_AND_USE_ON_ORDER: 개인정보 이용동의, PI_SELLER_PROVISION: 개인정보 판매자 제공 동의, CLEARANCE_INFO_COLLECTION_AND_USE: 통관정보 수집 · 이용 동의, TRANSFER_AGREE: 개인정보 국외 이전 동의, ORDER_INFO_AGREE: 주문 상품 정보 동의, PI_LIQUOR_PURCHASE_PROVISION: 주류구매 개인정보 제공 동의, REGULAR_PAYMENT_USE: 정기결제(배송) 이용약관, AUTO_APPROVAL_USE: 자동 승인 이용약관, ORDER_DEFAULT: 주문 기본 동의*/
                        ],
                        clientReturnUrl: `${process.env.REACT_APP_SHOP_URL}/closetest`,
                        clientParams: {},
                        inAppYn: 'Y',
                        paymentAmtForVerification: 0,
                        savesLastPayType: false,
                        applyCashReceipt: false,
                        cashReceipt: null,
                        bankAccountToDeposit: null,
                        remitter: null,
                        shippingAddresses: [],
                        rentalInfo: null,
                        myPayInfo: {
                          mobileInfo: { flagPin: 'Y', hppType: null },
                          accountInfo: null,
                          cardInfo: {
                            flagPin: 'Y',
                            flagCardPoint: 'N',
                            cardQuota: '00',
                            couponCode: null,
                            cardInterest: null,
                            bankCardCode: cardInfo[slideIdx]?.bankCardCode ? cardInfo[slideIdx]?.bankCardCode : null,
                          },
                          payMethod: '01',
                          wpayToken: cardInfo[slideIdx]?.payToken,
                        },
                        customTermsNos: null,
                        agreementTypes: null,
                        customTermsAgrees: [
                          {
                            customTermsNo: 1,
                            isAgree: true,
                          },
                        ],
                      }
                      const array: any = []
                      const cartList: any = getParsedLocalStorageItem('cartlist')
                      let cartArray: any = []
                      const couponTexts: any = []
                      couponText.map((element: any) => {
                        couponTexts.push(element.text)
                      })
                      const pixelContent_ids: number[] = []
                      const pixelContents: { name: string; quantity: number }[] = []

                      orderItem.map((el: any) => {
                        el.orderProductOptions.map((element: any, idx: number) => {
                          let price = 0
                          let couponTitle = ''
                          couponText.map((els: any) => {
                            if (el.productNo === els.productNo) {
                              price = els.price
                              couponTitle = els.text
                            }
                          })
                          pixelContent_ids.push(el?.productNo)
                          pixelContents.push({ name: el?.productName, quantity: element.orderCnt })
                          const obj = {
                            item_id: String(el?.productNo),
                            item_name: el?.productName,
                            affiliation: '어바웃피싱',
                            item_list_price: element.price?.salePrice,
                            item_selling_price: element.price?.salePrice - element.price?.immediateDiscountAmt,
                            price: element.price?.salePrice - element.price?.immediateDiscountAmt,
                            item_total_discount: element.price?.immediateDiscountAmt,
                            discount: price,
                            coupon: couponTitle,
                            index: 0,
                            item_brand: el.brandName,
                            quantity: element.orderCnt,
                            item_category: selectCategorys[idx]?.depth1Label,
                            item_category2: selectCategorys[idx]?.depth2Label,
                            item_category3: selectCategorys[idx]?.depth3Label,
                            item_variant: element.optionTitle,
                            item_list_id: undefined,
                            item_list_name: undefined,
                            promotion_id: undefined,
                            promotion_name: undefined,
                          }
                          array.push(obj)
                        })
                      })

                      if (cartList?.length !== 0) {
                        cartList?.map((ele: any) => {
                          for (let i = 0; i < array.length; i++) {
                            if (ele.product === array[i].item_id) {
                              array[i].item_list_id = ele.item_list_id
                              array[i].item_list_name = ele.item_list_name
                              array[i].promotion_id = ele.promotion_id
                              array[i].promotion_name = ele.promotion_name
                              cartArray.push(array[i])
                            }
                          }
                        })
                      } else {
                        cartArray = array
                      }
                      initiateCheckout(
                        pixelContent_ids,
                        pixelContents as [{ name: string; quantity: number }],
                        orderPrice?.cartAmt || 0
                      )
                      const viewItem: DataLayerArgs = {
                        dataLayer: {
                          event: 'add_payment_info',
                          ecommerce: {
                            currency: 'KRW',
                            payment_type: selectPay,
                            value: orderPrice?.cartAmt,
                            items: cartArray,
                            reserve_discount: submitAcc,
                            pay_back: orderPrice?.accumulationAmtWhenBuyConfirm,
                          },
                        },
                      }
                      if (isAppView) {
                        sendSetAppsflyerEvent({
                          eventName: 'add_payment_info',
                          eventType: {
                            currency: 'KRW',
                            payment_type: selectPay,
                            value: orderPrice?.cartAmt,
                            items: cartArray,
                            reserve_discount: submitAcc,
                            pay_back: orderPrice?.accumulationAmtWhenBuyConfirm,
                          },
                        })
                      } else {
                        TagManager.dataLayer(viewItem)
                      }

                      if (selectPayType === 'MY_PAY') {
                        if (cardInfo.length !== 0) {
                          const accesstoken = getParsedLocalStorageItem('accessToken')
                          if (isAppView || isMobile) {
                            if (isAppView) {
                              const encode = encodeURIComponent(JSON.stringify(option))
                              handlePostMessage({
                                actionType: 'onLink',
                                params: {
                                  url: `${
                                    process.env.REACT_APP_SHOP_URL
                                  }/mypaypaid?productdata=${encode}&payLogo=${JSON.stringify(
                                    myPayData
                                  )}&accesstoken=${accesstoken}&app=true`,
                                },
                              })
                            } else if (!isAppView && isMobile) {
                              const open = window.open('about:blank', '_blank')
                              const encode = encodeURIComponent(JSON.stringify(option))
                              //@ts-ignore
                              open.location.href = `${process.env.REACT_APP_SHOP_URL}/mypaypaid?productdata=${encode}&app=false`
                            }

                            // navigate('/orderFinish');
                          } else {
                            // @ts-ignore
                            if (NCPPay) {
                              // @ts-ignore
                              NCPPay.setMyPayCssCustom(
                                `https://shop-api.e-ncp.com${myPayData?.customCssUrl}`,
                                null,
                                `${myPayData?.payName}`,
                                null
                              )
                              // @ts-ignore
                              NCPPay?.setConfiguration({
                                clientId: process.env.REACT_APP_CLIENT_ID, // shopby에서 발급받은 clientId
                                confirmUrl: `${process.env.REACT_APP_SHOP_URL}/closetest`, // 결과를 리턴받을 url
                                platform: isMobile ? 'MOBILE_WEB' : 'PC', // 'PC or MOBILE_WEB or AOS or IOS'
                                accessToken: hasAccessToken ? getAccessToken() : '', // 로그인한 사람의 accessToken
                              })
                              // @ts-ignore
                              NCPPay?.reservation(option, function (response: any) {
                                // alert('실행');
                                const string = JSON.stringify(response)
                                const encodedData = encodeURIComponent(string)
                              })
                            }
                          }
                        } else {
                          alert('카드를 등록 후 사용해주세요')
                        }
                      } else if (selectPayType === 'KAKAO_PAY') {
                        // @ts-ignore
                        if (NCPPay) {
                          // @ts-ignore
                          NCPPay?.setConfiguration({
                            clientId: process.env.REACT_APP_CLIENT_ID, // shopby에서 발급받은 clientId
                            confirmUrl: `${
                              isMobile
                                ? `${process.env.REACT_APP_SHOP_URL}/orderFinish`
                                : `${process.env.REACT_APP_SHOP_URL}/closetest`
                            }`, // 결과를 리턴받을 url
                            platform: isMobile ? 'MOBILE_WEB' : 'PC', // 'PC or MOBILE_WEB or AOS or IOS'
                            accessToken: hasAccessToken ? getAccessToken() : '', // 로그인한 사람의 accessToken
                          })
                          // @ts-ignore
                          NCPPay?.reservation(option, function (response: any) {
                            // navigate('/orderFinish');
                          })
                        }
                      } else {
                        // @ts-ignore
                        if (NCPPay) {
                          // @ts-ignore
                          NCPPay?.setConfiguration({
                            clientId: process.env.REACT_APP_CLIENT_ID, // shopby에서 발급받은 clientId
                            confirmUrl: `${process.env.REACT_APP_SHOP_URL}/orderFinish`, // 결과를 리턴받을 url
                            platform: isMobile ? 'MOBILE_WEB' : 'PC', // 'PC or MOBILE_WEB or AOS or IOS'
                            accessToken: hasAccessToken ? getAccessToken() : '', // 로그인한 사람의 accessToken
                          })
                          // @ts-ignore
                          NCPPay?.reservation(option, function (response: any) {
                            // navigate('/orderFinish');
                          })
                        }
                      }
                    }}
                  >
                    {plusComma(paymentAmount)}원 구매하기
                  </BtnFixed>
                </div>
              </div>
            </div>
          </div>
          {visible && (
            <>
              <div
                className='dim'
                style={{
                  display: visible ? 'block' : 'none',
                  width: '100%',
                  height: '100vh',
                  zIndex: '20',
                  backgroundColor: 'rgba(0, 0, 0, 0.6)',
                  position: 'fixed',
                  top: '0',
                  left: '0',
                  overflow: 'hidden',
                }}
              >
                <div className='postcode_find_wrap'>
                  <div className='popup_header'>
                    <button title='닫기' onClick={() => setVisible(false)}>
                      <img
                        src='/images/icon_close.png'
                        alt=''
                        style={{
                          width: '100%',
                        }}
                      />
                    </button>
                  </div>
                  <div
                    className='popup_content'
                    style={{
                      background: 'var(--colWhite)',
                      position: 'absolute',
                      top: 'calc(50% + 20px)',
                      left: '50%',
                      transform: 'translate(-50%,-50%)',
                      width: '100%',
                      zIndex: 9999,
                      height: 390,
                      maxWidth: '95%',
                      border: '1px solid var(--colGray3)',
                    }}
                  >
                    <DaumPostcode onComplete={handleComplete} style={{ height: '100%', margin: `0 auto` }} />
                  </div>
                </div>
              </div>
            </>
          )}
          {deleteModal ? (
            <CardDeleteModal
              setIsModal={setDeleteModal}
              cardInfos={cardInfo}
              setChangePayData={setChangePop}
            ></CardDeleteModal>
          ) : null}
          {recentModal ? (
            isMobile ? (
              <OrderRecentModal
                setModalSelectAddress={setModalSelectAddress}
                setIsModal={setRecentModal}
              ></OrderRecentModal>
            ) : (
              <OrderRecentCenterModal
                setModalSelectAddress={setModalSelectAddress}
                setIsModal={setRecentModal}
              ></OrderRecentCenterModal>
            )
          ) : null}
          {isModal ? (
            isMobile ? (
              <OrderModal
                setIsModal={setIsModal}
                setCartCoupon={setCartCoupon}
                setCartCoupons={setCartCoupons}
                setTitle={setCartCouponTitle}
                cartCoupon={cartCoupon}
                selectCoupon={selectCoupon}
                setProductCoupon={setProductCoupon}
                productCoupon={productCoupon}
                setCouponText={setCouponText}
                couponText={couponText}
                //@ts-ignore
                orderSheetNo={params.orderSheetNo}
              ></OrderModal>
            ) : (
              <OrderCenterModal
                setIsModal={setIsModal}
                selectCoupon={selectCoupon}
                setProductCoupon={setProductCoupon}
                productCoupon={productCoupon}
                setCouponText={setCouponText}
                couponText={couponText}
                //@ts-ignore
                orderSheetNo={params.orderSheetNo}
              ></OrderCenterModal>
            )
          ) : null}
        </div>
        {pointModal ? (
          isMobile ? (
            <PointExchange
              coin={fishingCoin}
              memberNo={userData?.memberNo}
              setIsModal={setPointModal}
              setPointChange={setPointChange}
            ></PointExchange>
          ) : (
            <PointExchangeCenterModal
              coin={fishingCoin}
              memberNo={userData?.memberNo}
              setIsModal={setPointModal}
              setChangePointCheck={setPointChange}
            ></PointExchangeCenterModal>
          )
        ) : null}
        {/* 비회원 개인정보 수집 / 이용 동의 팝업 */}
        {agree ? <PrivacyInfoCollectionAgree isModal={agree} setIsModal={setAgree}></PrivacyInfoCollectionAgree> : null}
      </div>
    </>
  )
}

const SectionDiv = styled.div`
  padding: 24px 20px;
  @media screen and (min-width: 768px) {
    padding: 32px 0 32px 0;
    border-bottom: 1px solid var(--colGray3);
    &:last-child {
      border-bottom: none;
    }
  }
`

function ProductItems({
  el,
  element,
  idx,
  setIsModal,
  setSelectCoupon,
  orderItem,
  isModal,
  selectCoupon,
  setProductCoupon,
  productCoupon,
  selectCoupons,
  setSelectCoupons,
  couponText,
  setCouponText,
  categorys,
  setSelectCategorys,
}: any) {
  const [title, setTitle] = useState<string>()
  const [couponCalCulate, setCouponCalCulate] = useState<any>()
  const [items, setItems] = useState<any>([])
  const [includeBol, setIncludeBol] = useState<boolean>(false)
  const [selectCategory, setSelectCategory] = useState<any>([])
  const { hasAccessToken } = useCommonContext()
  const location = useLocation()
  const params = useParams()

  useEffect(() => {
    if (categorys) {
      const array: any = []
      el?.categoryNos?.map((element: any) => {
        const selectCategory = findObjectsWithValue(categorys.flatCategories, Number(element))
        if (selectCategory[0]?.depth1Label !== '브랜드') {
          array.push(...selectCategory)
        }
        setSelectCategory(array)
      })
    }
  }, [categorys])

  useEffect(() => {
    if (selectCategory) {
      setSelectCategorys((prev: any) => [...prev, ...selectCategory])
    }
  }, [selectCategory])

  useEffect(() => {
    if (couponText) {
      const foundItem = couponText?.find((item: any) => Number(item.productNo) === Number(el.productNo))
      if (foundItem) {
        setIncludeBol(true)
      } else {
        setIncludeBol(false)
      }
    }
  }, [couponText])

  useEffect(() => {
    if (couponText) {
      couponText.map((element: any) => {
        if (element.productNo === el.productNo) {
          const text = `${element.text}원 할인`
          setTitle(text)
        }
      })
    }
    if (couponText?.length === 0) {
      setTitle('')
    }
  }, [couponText])

  useEffect(() => {
    if (hasAccessToken) {
      //@ts-ignore
      getSubmitCoupons(params.orderSheetNo)
        .then((res) => {
          const array: any = []
          res.data.products.map((el: any) => {
            if (el.productNo === element.productNo) {
              array.push(el)
            }
          })
          setItems(array)
        })
        .catch((err) => console.log(err))
    }
  }, [])

  return (
    <>
      <div key={el.optionNo} className='item_list_wrap'>
        {el?.orderProductOptions?.map((element: any) => {
          return (
            <ProductItemOrder
              key={el.productNo}
              productNo={el.productNo}
              imgUrl={element.imageUrl}
              brand={element.brandName}
              setIsModal={setIsModal}
              option={element.optionTitle}
              orderCount={element.orderCnt}
              setSelectCoupon={setSelectCoupon}
              originPrice={plusComma(element.price?.standardAmt)}
              items={items}
              discount={
                couponCalCulate
                  ? Math.floor(
                      ((element.price?.immediateDiscountAmt + couponCalCulate?.productCouponDiscountAmt) /
                        element.price?.salePrice) *
                        100
                    )
                  : Math.floor((element.price.immediateDiscountAmt / element.price.salePrice) * 100)
              }
              totalPrice={couponCalCulate ? plusComma(couponCalCulate?.cartAmt) : plusComma(element.price.buyAmt)}
              productCoupon={productCoupon}
            ></ProductItemOrder>
          )
        })}

        {/* {Number(orderItem.length) === Number(idx + 1) ? null : (
          <div
            style={{
              height: 1,
              backgroundColor: 'var(--colGray3)',
              margin: isMobile ? '24px 0' : '32px 0',
            }}
          ></div>
        )} */}
      </div>
      {title && includeBol ? (
        <TooltipOrder
          content={title}
          setProductCoupon={setProductCoupon}
          productCoupon={productCoupon}
          selectCoupons={selectCoupons}
          setSelectCoupons={setSelectCoupons}
          setTitle={setTitle}
          setCouponCalCulate={setCouponCalCulate}
          productNo={items[0]?.productNo}
          setCouponText={setCouponText}
          couponText={couponText}
        ></TooltipOrder>
      ) : null}
    </>
  )
}
